import React, { useState } from "react"
import DataTable from "react-data-table-component"
import { Modal, ModalBody } from "reactstrap"
import Search from "../../../../../../components/common/Search/Search"

const SelectCustomersModal = ({ isModalOpen, setIsModalOpen }) => {

  const toggle = () => setIsModalOpen(!isModalOpen)

  const data = [
    { id: '001', name: 'Lorem ipsum', email: 'Loremipsum@gmail.com', phoneNo: '03411234560', status: "Active" },
    { id: '001', name: 'Lorem ipsum', email: 'Loremipsum@gmail.com', phoneNo: '03411234560', status: "Active" },
    { id: '001', name: 'Lorem ipsum', email: 'Loremipsum@gmail.com', phoneNo: '03411234560', status: "Active" },
    { id: '001', name: 'Lorem ipsum', email: 'Loremipsum@gmail.com', phoneNo: '03411234560', status: "Active" },
    { id: '001', name: 'Lorem ipsum', email: 'Loremipsum@gmail.com', phoneNo: '03411234560', status: "Active" },
  ]

  const columns = [
    { name: 'Customer ID', selector: row => row.id },
    { name: 'Customer name', selector: row => row.name },
    { name: 'Email Address', selector: row => row.email },
    { name: 'Phone number', selector: row => row.phoneNo },
    { name: 'Status', selector: row => row.status },
  ]

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#f2f2f2",
        fontSize: "0.938rem",
        fontWeight: 500,
      },
    },
    cells: {
      style: {
        paddingBlock: "1rem",
      },
    },
  }

  return (
    <div>
      <Modal
        isOpen={isModalOpen}
        toggle={toggle}
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          minHeight: "484px",
          minWidth: "50%",
          maxWidth: "80%",
        }}
      >
        <ModalBody>
          <div className="d-flex align-items-center justify-content-between mb-2">
            <h5 className="mt-3">Select Customer</h5>
            <Search placeholder='Customer name or ID' />
          </div>


          <DataTable columns={columns} data={data} customStyles={customStyles} />

          <div className="d-flex justify-content-end mt-3">
            <div className="d-flex gap-2 fw-medium">
              <div className="border border-dark rounded rounded-3 px-2 py-1 cursor-pointer" onClick={toggle}>Cancel</div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default SelectCustomersModal
